






import { defineComponent, reactive, ref, watch } from '@vue/composition-api';

import { Line as LineChart } from 'vue-chartjs/legacy';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip);

export default defineComponent({
	components: { LineChart },

	props: {
		series: {
			type: Array,
			required: true,
		},
	},

	setup(props) {
		const calculateSeries = () => ({
			labels: Array.from(Array(props.series.length).keys()),
			datasets: [
				{
					backgroundColor: '#007151',
					borderColor: '#007151',
					data: props.series,
					borderWidth: 2,
				},
			],
		});

		const chartData = ref<any>(calculateSeries());

		const chartOptions = reactive<any>({
			responsive: true,
			maintainAspectRatio: false,
			locale: 'de-DE',
			elements: {
				point: {
					radius: 0,
					hitRadius: 10,
					hoverRadius: 6,
					pointStyle: 'rect',
				},
			},
			scales: {
				x: {
					grid: {
						tickLength: 0,
					},
					type: 'linear',
					bounds: 'data',
					offset: false,
					ticks: {
						align: 'inner',
						padding: 10,
						stepSize: 10,
						min: 0,
						callback: function(value: number, index: number, values: number[]) {
							const max = Math.floor((this as any).max / 10) * 10;
							if (value <= max) return value + ' Jahre';
						},
					},
				},
				y: {
					grid: {
						tickLength: 0,
					},
					ticks: {
						align: 'end',
						padding: 10,
						callback: function(value: number, index: number, values: number[]) {
							return value + ' EUR';
						},
					},
				},
			},
			plugins: {
				tooltip: {
					backgroundColor: '#ebf5f2',
					titleColor: '#333',
					titleFont: {
						size: 18,
						weight: 'normal',
						family: "'rb-galano-neue',Arial,Helvetica,sans-serif",
					},
					bodyColor: '#333',
					bodyFont: {
						size: 15,
						family: 'Arial,Helvetica,sans-serif',
					},
					footerColor: '#333',

					callbacks: {
						title: function(items: any) {
							return items[0].raw.text;
						},
						label: function() {
							return;
						},
						afterBody: function(items: any) {
							const item = items[0];
							const initialValue = item.dataset.data[0].y;
							const currentDue = item.raw.y;
							const formatter = new Intl.NumberFormat('de-DE');
							return [
								`Getilgt: ${formatter.format(initialValue - currentDue)} EUR`,
								`Restschuld: ${formatter.format(currentDue)} EUR`,
							];
						},
					},
				},
			},
		});

		watch(
			() => props.series,
			() => {
				chartData.value = calculateSeries();
			},
		);

		return {
			chartData,
			chartOptions,
		};
	},
});
